import {ICacheStorage} from "../../data/protocols/cache";

export class SessionStorageAdapter implements ICacheStorage {
  set(key: string, value: string): void {
    if (value) {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.removeItem(key);
    }
  }

  get(key: string): any {
    return sessionStorage.getItem(key);
  }
}
